import { render } from "./RuiClose.vue?vue&type=template&id=0499184e"
const script = {}
script.render = render

export default script